import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import { orders } from "../../../../../../redux/orders/action";
import { selectOrdersListItems } from "../../../../../../redux/orders/selector";
import { useNavigate } from "react-router-dom";
import { selectListItems } from "../../../../../../redux/library/selector";
import PageLoader from "../../../../../../components/PageLoader";
import Table from "../../../../../../common/components/table-manager/v1.1/table";
import storePersist from "../../../../../../redux/storePersist";
import _ from "lodash";

const CustomerOrders = () => {
  const roleData = _.find(storePersist.get('userProfile')?.current?.items[0]?.Roles, ['Name', 'RAPCustomer']);
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageSize, setPageSize] = useState(10);
  const [pageData, setPageData] = useState(1)
  const itemsData = useSelector(selectOrdersListItems)
  const libraryData = useSelector(selectListItems)
  const [
    columnDefs,
    setColumnDefs
  ] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'MobilityOrderPId', headerName: 'Order PId', sortable: true, filter: true, searchField: 'MobilityOrderPId', filterType: 'text' },
      { field: 'InvoiceNumber', headerName: 'Invoice Number', sortable: true, filter: true, },
      { field: 'RAPName', headerName: 'RAP Name' },
      { field: 'RAPAgentName', headerName: 'RAPAgent Name' },
      { field: 'RAPCustomerName', headerName: 'Customer Name' },
      { field: 'MobilityOrderNotes', headerName: 'MobilityOrder Notes', sortable: false, filter: true },
      { field: 'MobilityOrderStatusId', headerName: 'Order Status', cellRenderer: 'libraryRendererComponent', cellRendererParams: { library: libraryData?.result?.OrderStatus, isRowColorDecider: true, isRowMenuSelect: false, anchorPosition: 'top-left' } },
      // {
      //   field: 'Repeat Order',
      //   headerName: 'Repeat Order',
      //   cellRenderer: 'buttonRenderer',
      //   buttonName: 'Repeat order',
      // },
      // { field: 'Download Invoice', headerName: 'Download Invoice',PDFName: 'Download Invoice',isPrintandDownloadPDF:true },
      { field: 'ScheduledDate', headerName: 'Scheduled Date', isDateValueFormat: true, },
      { field: 'CreatedOnUtc', headerName: 'Order Date', isDateValueFormat: true, },
    ]);
  }
  const fetchOrders = async () => {
    await dispatch(orders.resetAction({ actionType: 'list' }))
    await dispatch(orders.list({
      url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/sales/orders/list`, entity: 'order', jsonData: {

        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        // "Filters": [
        //   {
        //     "FieldName": "RAPCustomerId",
        //     "FilterOperatorId": 1,
        //     "FieldValue": roleData?.Id,
        //     "FieldType": "number"
        //   }]

      }
    }))
  }
  const handleReloadData = () => {
    fetchOrders()
  }
  useEffect(() => {
    createColumnDefs()
    fetchOrders()
  }, [pageData, pageSize])

  const handleEdit = (data: any) => {

    navigate(`${data?.Id}`)
  }
  const additionButtons: any = [

    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload this table</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      callback: () => handleReloadData(),
    }
  ];
  const handleSearch = (data: any) => {
    let searchCriteria = {};
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column,
        FieldText: data?.column,
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "MobilityOrderPId",
        FieldText: "MobilityOrderPId",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    }
    dispatch(orders.list({
      url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/sales/orders/list`, entity: 'orders', jsonData: {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        "Searches": searchCriteria,
        // "Filters": [
        //   {
        //     "FieldName": "RAPCustomerId",
        //     "FilterOperatorId": 1,
        //     "FieldValue": roleData?.Id,
        //     "FieldType": "number"
        //   }]
      }
    }));
  }
  return (
    <>
      {itemsData?.isLoading ? <PageLoader />
        :
        <Table
          checkboxConfig={{
            allowMultiSelect: true,
            defaultSelectedIds: [],
            isDisabled: false,
            keyColumn: 'Id',
          }}
          enableFilter={true}
          onSearch={handleSearch}
          columnData={columnDefs}
          rowData={itemsData?.result?.items}
          onEdit={handleEdit}
          setPageData={setPageData}
          setPageSize={setPageSize}
          additionButtons={additionButtons}
          paginationData={itemsData?.result?.pagination}
          headingName="Orders" />
      }
    </>



  );
};

export default CustomerOrders;


